export const errorClassification = (error) => {
  console.log(error)
  const result = {modal: true, message: ''}
  if(error.response && error.response.status===422 && error.response.data.errors.length > 0){
    result.message = error.response.data.errors.join("<br />")
  } else if(error.response && error.response.status===401){
    result.message = error.response.data.error
  } else {
    if(error.code === 'ERR_NETWORK'){
      result.message = "Verifique su conexion a internet"
    } else if(error.code === 'ECONNABORTED'){
      result.message = "Conexión lenta. Verifique su conexion a internet"
    } else {
      result.modal = false
      alert(error)
    }
  }

  return result;
}
